<template>
  <div>
    <div class="md-layout">
      <div
        class="md-layout-item md-size-100 status"
        :class="enquiry.status.value"
      >
        <h6>Status: {{ enquiry.status.description }}</h6>
      </div>
      <div
        v-if="enquiry.follow_up"
        class="md-layout-item md-size-100 follow-up"
        :class="dueStatus"
      >
        <h6>Follow Up: {{ enquiry.follow_up | formatDate }}</h6>
      </div>

      <div class="md-layout-item md-size-90 tours-header">
        <h6>Tours</h6>
      </div>
      <div class="md-layout-item md-size-10 text-right">
        <md-button
          class="md-icon-button md-dense md-primary md-simple"
          @click="addTour"
        >
          <md-icon>add</md-icon>
          <md-tooltip md-direction="top">Show Interest for a Tour</md-tooltip>
        </md-button>
      </div>

      <div class="md-layout-item md-size-100 tours">
        <div v-show="!enquiry.tours.length">
          No Tours selected
        </div>
        <md-chips
          v-show="enquiry.tours.length"
          v-model="enquiryTourChips"
          class="md-primary"
        >
          <template slot="md-chip" slot-scope="{ chip }">
            {{ chip }}
          </template>
        </md-chips>
      </div>

      <div class="md-layout-item md-size-50">
        <md-field>
          <md-icon class="heat" :class="ratingColour">star_rate</md-icon>
          <label>Potential</label>
          <md-input
            v-model="enquiry.heat"
            type="number"
            min="1"
            max="5"
          ></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-50">
        <md-field>
          <md-icon
            ><i class="fas fa-pound-sign text-primary hi-price-icon"></i
          ></md-icon>
          <label>Estimated Value</label>
          <md-input v-model="enquiry.value" type="text"></md-input>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50">
        <div class="caption">Travel Date</div>
        <date-picker
          prefix-class="xmx"
          v-model="enquiry.travel_date"
          valueType="format"
          type="month"
          placeholder="Travel Date"
        ></date-picker>
      </div>
      <div class="md-layout-item md-size-50">
        <div class="caption">Follow Up Date</div>
        <date-picker
          prefix-class="xmx"
          v-model="enquiry.follow_up"
          valueType="format"
          type="date"
          placeholder="Select Follow-up Date"
        ></date-picker>
      </div>

      <div class="md-layout-item md-size-100 mt-4">
        <div class="md-caption">Created On</div>
        <div>{{ enquiry.created_at | formatDate }}</div>
      </div>

      <div class="md-layout-item md-size-100">
        <md-button
          class="md-dense md-raised md-success mt-4"
          @click.prevent="updateEnquiry"
          >Update</md-button
        >
      </div>
    </div>

    <enquiry-tour-dialog
      :viewTourDialog="viewTourDialog"
      :availableTours="availableTours"
      @add="newTour"
      @cancel="viewTourDialog = false"
    />
  </div>
</template>

<script>
import enquiryApi from "@/services/api/enquiry";
import optionsApi from "@/services/api/options";
import tourApi from "@/services/api/tour";

import EnquiryTourDialog from "./EnquiryTourDialog";

import moment from "moment";

export default {
  props: {
    enquiry: Object
  },

  components: {
    EnquiryTourDialog
  },

  data() {
    return {
      tours: [],
      managers: [],
      viewTourDialog: false
    };
  },

  methods: {
    updateEnquiry() {
      enquiryApi
        .updateEnquiry(this.enquiry)
        .then(response => {
          this.$notify({
            timeout: 2500,
            message: "The Enquiry has been updated.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(error => {});
    },

    addTour() {
      this.viewTourDialog = true;
    },

    newTour(tourId) {
      let tour = this.tours.find(tour => tour.id === tourId);
      this.enquiry.tours.push(tour);
      this.viewTourDialog = false;
    }
  },

  computed: {
    availableTours() {
      return this.tours.filter(
        tour => !this.enquiry.tours.find(rm => rm.id === tour.id)
      );
    },

    dueStatus() {
      let followUp = moment(this.enquiry.follow_up, "YYYY-MM-DD");
      let days = moment
        .duration(followUp.diff(moment().startOf("day")))
        .asDays();

      switch (true) {
        case days < 1:
          return "overdue";
          break;
        case days < 7:
          return "upcoming";
          break;
        default:
          return "default";
          break;
      }
    },

    ratingColour() {
      switch (+this.enquiry.heat) {
        case 1:
        case 2:
          return "cool";
          break;
        case 3:
          return "medium";
          break;
        case 4:
        case 5:
          return "hot";
          break;
        default:
          return "";
      }
    },

    enquiryTourChips: {
      get() {
        return this.enquiry.tours.map(tour => tour.title);
      },
      set(tours) {
        this.enquiry.tours = this.enquiry.tours.filter(tour =>
          tours.includes(tour.title)
        );
      }
    },

    selectedManager: {
      get: function() {
        return this.enquiry.manager.id;
      },
      set: function(value) {
        this.enquiry.manager.id = value;
      }
    }
  },

  watch: {},

  beforeMount() {
    optionsApi.managers().then(resp => {
      this.managers = resp.data;
    });
    tourApi.getTours().then(resp => {
      this.tours = resp.data.tours;
    });
  }
};
</script>
<style lang="scss" scoped>
.xmx-datepicker {
  width: 100%;
}

.follow-up {
  border-radius: 10px;
  margin-bottom: 1rem;

  h6 {
    margin: 1rem 0;
  }
  &.overdue {
    background-color: #f6acac;
  }
  &.upcoming {
    background-color: #cef2d4;
  }
  &.default {
    background-color: #f6f6f6;
  }
}

.status {
  border-radius: 10px;
  margin-bottom: 1rem;

  h6 {
    margin: 1rem 0;
  }
  &.ongoing {
    background-color: #f6f6f6;
  }
  &.negative {
    background-color: #f6acac;
  }
  &.positive {
    background-color: #cef2d4;
  }
  &.deferred {
    background-color: #faedc5;
  }
}

.tours-header {
  h6 {
    margin-bottom: 0;
  }
}

.tours {
  margin-bottom: 1rem;

  .md-chips {
    &.md-field {
      padding-top: 0;
      margin-top: 0px;
    }

    ::v-deep.md-chip {
      height: 30px;
      line-height: 30px;
    }
  }
}
</style>
